import { styled, Loader } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { getClients } from "@/api";
import {
  CasePriorities,
  DetailItem,
  DetailLabel,
  DetailValue,
} from "@/Features";
import { Case } from "../cases.types";

const CustomDetailItem = styled(DetailItem)`
  gap: 0px;
  padding-bottom: 0px;
`;

export const CaseInfoTooltipContent = ({
  caseData,
}: {
  caseData?: Case | null;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ["clients", "list", { client_id: caseData?.client_id }],
    queryFn: () => getClients({ client_id: caseData?.client_id }),
    enabled: !!caseData?.client_id,
  });

  if (isLoading) return <Loader />;

  const clientInfo = data?.[0];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <CustomDetailItem>
        <DetailLabel>Case Number</DetailLabel>
        <DetailValue>{caseData?.case_number ?? "N/A"}</DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Name</DetailLabel>
        <DetailValue>{caseData?.case_ref ?? "N/A"}</DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Type</DetailLabel>
        <DetailValue>{caseData?.case_type ?? "N/A"}</DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Status</DetailLabel>
        <DetailValue>{caseData?.case_status ?? "N/A"}</DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Priority</DetailLabel>
        <DetailValue>
          {CasePriorities.find((p) => p.priority_id === caseData?.priority_id)
            ?.priority_name ?? "None"}
        </DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Open Date</DetailLabel>
        <DetailValue>
          {caseData?.case_open_date
            ? moment
                .utc(caseData?.case_open_date)
                .local()
                .format("MMMM DD, yyyy HH:mm A")
            : "N/A"}
        </DetailValue>
      </CustomDetailItem>
      <CustomDetailItem>
        <DetailLabel>Case Lead</DetailLabel>
        <DetailValue>
          {caseData?.case_lead?.full_name
            ? caseData?.case_lead?.full_name
            : "N/A"}
        </DetailValue>
      </CustomDetailItem>
      {clientInfo && (
        <CustomDetailItem>
          <DetailLabel>Client Info</DetailLabel>
          <DetailValue>
            <div>{clientInfo.name}</div>
            <div>{clientInfo.title}</div>
            <div>{clientInfo.organization}</div>
            <div>{clientInfo.email}</div>
            <div>{clientInfo.address}</div>
            {clientInfo.city && (
              <div>
                {clientInfo.city}, {clientInfo.state} {clientInfo.zipcode}
              </div>
            )}
            <div>{clientInfo.office_number}</div>
          </DetailValue>
        </CustomDetailItem>
      )}
    </div>
  );
};
